/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type RotateRequestBody = {
  /**
   * The key ID currently active, as last read. Required unless the issuer has no active key.
   */
  activeKid?: string | undefined;
  /**
   * Revoke every current key immediately instead of rotating gradually.
   */
  compromised?: boolean | undefined;
};

/** @internal */
export type RotateRequestBody$Outbound = {
  active_kid?: string | undefined;
  compromised: boolean;
};

/** @internal */
export const RotateRequestBody$outboundSchema: z.ZodMiniType<
  RotateRequestBody$Outbound,
  RotateRequestBody
> = z.pipe(
  z.object({
    activeKid: z.optional(z.string()),
    compromised: z._default(z.boolean(), false),
  }),
  z.transform((v) => {
    return remap$(v, {
      activeKid: "active_kid",
    });
  }),
);

export function rotateRequestBodyToJSON(
  rotateRequestBody: RotateRequestBody,
): string {
  return JSON.stringify(
    RotateRequestBody$outboundSchema.parse(rotateRequestBody),
  );
}
